<template>
    <div class="product min-contain">
        <div class="backImg max-contain"></div>
        <div class="product-main">
            <div class="main-business">
                <div class="title">主营业务</div>
                <div class="title-eng">INDUSTRIAL SERVICE</div>
                <div class="text">
                    <div v-for="(item, index) in bussinessInfo" :key="index" class="text-item">
                        <div class="name">{{ item.name }}</div>
                        <div>{{ item.desc }}</div>
                    </div>

                </div>
            </div>
            <div class="product-advantages">
                <div class="title">产品优势</div>
                <el-divider>PRODUCT ADVANTAGES</el-divider>
                <div class="product-advantages-contain">
                    <div class="item" v-for="(v, key) in advantagesInfo" :key="key">
                        <img :src="v.img" alt="">
                        <div class="text">{{ v.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Product',
    data() {
        return {
            bussinessInfo: [
                {
                    name: '专线业务',
                    desc: '以包裹为维度，从包裹国内揽收—包裹海外签收的全链路服务'
                },
                {
                    name: '头程业务',
                    desc: '平台物流全链路中的国内段货运、报关、空运托管服务'
                },
                {
                    name: "尾程业务",
                    desc: '跨境包裹末端派送。主要涵盖的服务内容：机场提取，包裹清关，交邮派送'
                },
                {
                    name: "增值服务",
                    desc: '长期专业车队合作，随时为客户提供到厂提货和派送服务。目前在东莞、广州、义乌、肇庆，深圳等地开设有运营仓库，占地面积达3.6万㎡。'
                }
            ],
            advantagesInfo: [
                {
                    name: '物流轨迹实时可视',
                    img: require('../assets/other/product1.png')
                },
                {
                    name: '咨询专业清关高效',
                    img: require('../assets/other/product2.jpg')
                },
                {
                    name: '退件管理按需重派',
                    img: require('../assets/other/product3.png')
                },
                {
                    name: '商户平台多方认可',
                    img: require('../assets/other/product4.jpg')
                },
            ]
        }
    }
}
</script>

<style lang="less" scoped>
.backImg {
    background-image: url('../assets/other/index1.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 672px;
    min-height: 40vh;
    width: 100%;
    z-index: -1;
    position: fixed;
    top: 0;
}

.main-business {
    background: rgba(0, 0, 0, 0.5);
    height: 460px;
    min-height: 40vh;
    width: 100%;
    // padding-top: 100px;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
        font-size: 24px;
        text-align: center;

    }
    .title-eng{
        text-align: center;
        margin-top: 10px;  
        font-size: 14px;
    }

    .text {
        display: flex;
        justify-content: center;
        margin-top: 3%;
    }

    .text-item {
        width: 280px;
        height: 170px;
        padding: 0 15px;
        background: rgba(255, 255, 255, 0.3);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        text-align: center;

        .name {
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 20px;

        }

        &:hover {
            background-color: rgba(0, 0, 0, 0.5);
            cursor: pointer;
            border-bottom: 2px solid #3399FF;
        }
    }
}

.product-advantages {
    height: 650px;
    min-height: 60vh;
    background: #fff;
    padding: 30px 10px;

    .title {
        font-size: 24px;
        text-align: center;
        color: #000;
    }
    .product-advantages-contain {
        display: flex;
        align-content: center;
        justify-content: space-evenly;
        margin-top: 3%;
        height: 90%;

        .item {
            height: 480px;
            min-height: 80%;
            width: 22%;
            border: 1px solid #ccc;
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
                width: 100%;
                height: 55%;
                object-fit: cover;
            }
            .text{
                color: #00309F;
                font-size: 40px;
                width: 180px;
                height: 45%;
                display: flex;
                align-items: center;
                &:hover{
                    color: #3366FF;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>